import React, { lazy, useEffect, useState } from 'react';
import { getSessionItem } from '../../webStorage/sessionStorage';
import SuspenseWrapper from './suspenseWrapper';

const LocationPopupImporter = ({ setIscurrentLocationAvailable }) => {
  const [LocationPopup, setLocationPopup] = useState(null);
  useEffect(() => {
    const selectedAddress = JSON.parse(getSessionItem('user_address'))?.address;
    if (selectedAddress) return;
    (async () => {
      const permissionStatus = await navigator.permissions.query({
        name: 'geolocation',
      });

      setLocationPopup(
        permissionStatus.state != 'granted' &&
          lazy(() => import(/* webpackChunkName:"LocationPopUp"*/ '../popUp/locationPopup'))
      );
    })();
  }, []);
  return (
    <>
      {LocationPopup && (
        <SuspenseWrapper>
          <LocationPopup
            setIscurrentLocationAvailable={setIscurrentLocationAvailable}
            closeLocationPopUp={() => setLocationPopup(false)}
          />
        </SuspenseWrapper>
      )}
    </>
  );
};

export default LocationPopupImporter;
